<template>
  <div>
    <v-card-title class="text-left card-header fixed-card-title2">{{ $t('add-license') }}
      <v-spacer></v-spacer>
      <v-icon class="white--text float-end mr-1" @click="closeDrawer">mdi-close</v-icon>
    </v-card-title>
<!--    {{selectedLicense}}-->
<!--    {{relatedPatients}}-->
    <v-text-field class="ma-2" :label="$t('search')" outlined dense hide-details v-model="search"></v-text-field>
    <v-data-table
    :items="getFilteredPatients"
     v-if="getFilteredPatients"
    :items-per-page="-1"
    dense
    fixed-header
    :height="pageHeight(160)"
    hide-default-footer
    :loading="loading"
    :no-data-text="$t('no-data-available')"
    :loading-text="$t('loading')"
    :headers="headers"
    :search="search"
    >
      <template v-slot:item="{item}">
        <tr @click="getSelectedPatient(item)">
          <td class="text-left">
           <span class="font-size13 font-weight-medium">{{item.firstName + " " + item.lastName}}</span>
          </td>
          <td>
            <div class="text-right float-right">
              <v-radio-group hide-details v-model="selectedPatient">
                <v-radio class="mt-n5" :value="item.id"></v-radio>
              </v-radio-group>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-card-actions class="fixed-card-actions">
      <v-row class="mb-0">
        <v-col cols="6">
          <v-btn
              @click="closeDrawer"
              elevation="0"
              class="cancel-button-style capitalize-text"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn
              @click="save"
              class="save-button-style"
          >
            {{ $t("save") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { showErrorAlert, showSuccessAlert } from '@/utils/utilities';

export default {
  name: 'AssignPatientToLicenseDrawer.vue',
  data () {
    return {
      selectedPatient: null,
      fetchedPatients: false,
      loading: false,
      search: '',
    };
  },
  methods: {
    getLicenses () {
      this.loading = true;
      this.$store.dispatch('licenses/getLicenses').then(res => {
        this.loading = false;
      });
    },
    async save () {
      try {
        const body = {
          licenseId: this.selectedLicense.id,
          patientUserId: this.selectedPatient,
        };
        const response = await this.$store.dispatch('licenses/assignLicenseForPatient', body);
        if (response.resFlag && response.statusCode === 201) {
          const index = this.relatedPatients.findIndex(
              patient => patient.id === response.data.patientUserId,
          );
          if (index !== -1) {
            this.relatedPatients.splice(index, 1);
          }
        // Check if the response is successful
        this.getLicenses();
        showSuccessAlert(response.msg);
        this.closeDrawer();
        }
      } catch (error) {
        showErrorAlert(error.response.data.msg);
        return error;
      }
    // Call endpoint to assign a licence to a patient.
    },
    getSelectedPatient (item) {
      this.selectedPatient = item.id;
    },
    async getPatients () {
      this.loading = true;
      this.fetchedPatients = false;
      await this.$store.dispatch('hospitals/getRelatedPatientsV4', this.userData.hospitalAssignedData.id)
          .then(() => {
            this.loading = false;
            this.fetchedPatients = true;
          });
    },
    closeDrawer () {
      this.$store.commit('SET_DETAILS_DRAWER', false);
      this.selectedPatient = null;
    },
  },
  computed: {
    getFilteredPatients () {
    // Patients
      if (this.fetchedPatients) {
        return this.relatedPatients?.filter(
            patient => patient.status === 1 &&
                // (patient.isRtmEnabled === true || patient.isRpmEnabled === true) &&
                patient.isLicensed === false,
        );
      } else {
        return [];
      }
    },
    ...mapState({
      selectedLicense: state => state.item,
      userData: (state) => state.authentication.userData,
      relatedPatients: (state) => state.hospitals.relatedPatients,
      detailsDrawer: (state) => state.detailsDrawer,
    }),
    ...mapGetters({
      roleName: 'authentication/getRole',
      pageHeight: 'pageHeight',
    }),
    headers () {
      const headers = [
        {
          text: this.$t('patient-name'),
          value: 'fullname',
          class: 'table-header px-0 mx-0 pl-4',
          align: 'start',
        },
        {
          text: this.$t('actions'),
          class: 'table-header  mr-12',
          align: 'end',
          value: '',
        },
        ];
      return headers;
    },
  },
  watch: {
    detailsDrawer: {
      handler (newVal) {
        if (newVal) {
          this.getPatients();
        }
        // this.getUsersForMapping();
      },
      deep: true,
      immediate: true,
    },
  },
  // mounted () {
  //   this.getPatients();
  // },
};
</script>
